import React from "react";
import styled from "styled-components";
import SearchBar from "../../Generic/SearchBar";
import Dropdown from "../../Generic/Dropdown";
import { zIndex } from "../../config/zIndex";
import { buildRestaurantDropdownOptions } from "../utils/offersListFilters";
import useMachines from "../../util/hooks/useMachines";

const StickyBar = styled.div`
	z-index: ${zIndex.topRow};
	background: #f7f7f8;
	padding: 1.5rem 1.5rem 1rem;
	margin: -1.5rem -1.5rem 0;
	border-bottom: 1px solid #e5e5e5;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	flex-shrink: 0;
`;

const HeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const Header = styled.div`
	display: flex;
	font-size: 2rem;
	margin: 0 0 0 0.5rem;
`;

const FiltersRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.75rem 1rem;
`;

const SearchWrap = styled.div`
	flex: 1 1 16rem;
	min-width: 12rem;
	max-width: 28rem;
`;

const DropdownWrap = styled.div`
	flex: 0 1 18rem;
	min-width: 12rem;
`;

const ActiveRestaurant = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.35rem 0.75rem;
	border-radius: 999px;
	background: #e8eef8;
	color: #36395a;
	font-size: 0.9rem;
	border: 1px solid #c5d4ef;
`;

const ClearButton = styled.button`
	appearance: none;
	border: none;
	background: transparent;
	cursor: pointer;
	padding: 0;
	margin: 0;
	line-height: 1;
	color: #36395a;
	display: inline-flex;
	align-items: center;

	&:hover {
		color: #1a1c2e;
	}
`;

const OffersFilterBar = ({
	searchInput,
	onSearchInputChange,
	restaurantId,
	onRestaurantChange,
	headerActions,
}) => {
	const { machines, loading } = useMachines();
	const options = buildRestaurantDropdownOptions(machines);

	return (
		<StickyBar>
			<HeaderRow>
				<Header>Offers</Header>
				{headerActions}
			</HeaderRow>
			<FiltersRow>
				<SearchWrap>
					<SearchBar
						placeholder="Search by title or code"
						value={searchInput}
						onChange={(e) => onSearchInputChange(e.target.value)}
					/>
				</SearchWrap>
				<DropdownWrap>
					{!loading ? (
						<Dropdown
							key={"restaurant-dropdown"}
							head="Restaurant"
							value={restaurantId || ""}
							optionsList={options}
							onChange={(value) => onRestaurantChange(value)}
							border="1px solid #d0d0d0"
							boxShadow="none"
							margin="0"
							heightVal="2.5rem"
							maxHeight="14rem"
						/>
					) : null}
				</DropdownWrap>
				{restaurantId ? (
					<ActiveRestaurant>
						<span>Filtering: {restaurantId}</span>
						<ClearButton
							type="button"
							aria-label="Clear restaurant filter"
							onClick={() => onRestaurantChange("")}>
							<span className="material-symbols-outlined" style={{ fontSize: "1.1rem" }}>
								close
							</span>
						</ClearButton>
					</ActiveRestaurant>
				) : null}
			</FiltersRow>
		</StickyBar>
	);
};

export default OffersFilterBar;
